export default [
	{
		path: "/admin/images",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminImages",
		mui: true,
	},
];
